var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcOpenInWindowLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.625 2.3C1.625 1.92721 1.92721 1.625 2.3 1.625H13.7C14.0728 1.625 14.375 1.92721 14.375 2.3V13.7C14.375 14.0728 14.0728 14.375 13.7 14.375H5.33333C5.12623 14.375 4.95833 14.2071 4.95833 14C4.95833 13.7929 5.12623 13.625 5.33333 13.625H13.625V2.375H2.375V10.6667C2.375 10.8738 2.20711 11.0417 2 11.0417C1.79289 11.0417 1.625 10.8738 1.625 10.6667V2.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33345 8.375C5.12634 8.375 4.95845 8.20711 4.95845 8C4.95845 7.79289 5.12634 7.625 5.33345 7.625H8.00012C8.20722 7.625 8.37512 7.79289 8.37512 8V10.6667C8.37512 10.8738 8.20722 11.0417 8.00012 11.0417C7.79301 11.0417 7.62512 10.8738 7.62512 10.6667V8.90533L2.59862 13.9318C2.45217 14.0783 2.21473 14.0783 2.06829 13.9318C1.92184 13.7854 1.92184 13.5479 2.06829 13.4015L7.09479 8.375H5.33345Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcOpenInWindowLined);
export default __webpack_public_path__ + "static/media/ic_open_in_window_lined.2e621863fd7f37eb0207d53f9e8de031.svg";
export { ForwardRef as ReactComponent };